import ArrowIcon from "@/assets/svgs/arrow";
import { Button } from "@quest/ui/components/button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface IcaresPopupProps {
  onClose: () => void;
}

function IcaresPopup({ onClose }: IcaresPopupProps) {
  const { t } = useTranslation("New");

  const navigate = useNavigate();

  const handleTakeTest = () => {
    navigate("/icares-tools?tab=occupations");
    onClose();
  };

  return (
    <div className="flex flex-col gap-8 mt-8">
      <p className="text-center font-medium">{t("icaresTestInstructions")}</p>
      <div className="flex justify-center items-center">
        <Button
          data-testid="take-first-test-button"
          className="hover:bg-primary/80"
          onClick={handleTakeTest}
        >
          {t("takeTheFirstTest")}

          <div className="bg-secondary hover:bg-primary transition-all duration-300 ml-5 rounded-full w-[40px] h-[40px] flex items-center relative">
            <div className="absolute right-[12px] ">
              <ArrowIcon />
            </div>
          </div>
        </Button>
      </div>
    </div>
  );
}

export default IcaresPopup;
